<form [formGroup]="form" style="all: unset;">
    <ng-container *ngIf="sections && sections.length > 0 && sections[0].id !== -100">
        <mat-card *ngFor="let section of sections">
            <mat-card-title *ngIf="section.caption && section.caption!==''">{{section.caption}}</mat-card-title>
            <mat-divider *ngIf="section.caption && section.caption!==''"></mat-divider>
            <mat-card-content class="card-content">
                <ng-container *ngFor="let config of section.fields" wtfDynamicField [form]="this" [model]="model" [config]="config" [group]="form" [components]="componentsContainer"></ng-container>
            </mat-card-content>
        </mat-card>
    </ng-container>
    <ng-container *ngIf="sections && sections.length === 1 && sections[0].id == -100">
        <ng-container *ngFor="let config of sections[0].fields" wtfDynamicField [form]="this" [model]="model" [config]="config" [group]="form" [components]="componentsContainer"></ng-container>
    </ng-container>

     <div class="row-fluid">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-24">
            <button class="mat-raised-button mat-warn mat-red-bg pull-left" *ngIf="showCancelButton" (click)="performCancel()"> {{cancelButtonCaption || 'CANCEL'}}</button>
            <button class="mat-raised-button mat-accent pull-right" *ngIf="showAcceptButton" (click)="performAccept()">{{acceptButtonCaption || 'OK'}}</button>
        </div>
    </div>

    <!-- <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 mb-24">
        {{formRepresentation}}
    </div> -->
</form>
